module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Login"},"en":{"title":"Contact"}}')
  delete Component.options._Ctor
}
